'use strict';

document.addEventListener('DOMContentLoaded', () => {

	const healthcareWorker = document.getElementById('is_healthcare_workers');

	if(healthcareWorker){

		// popupのcookie制御
		const popup = document.getElementById('js-popup');
		const popupBtnYes = document.getElementById('js-popupYes');
		const popupBtnNo = document.getElementById('js-popupNo');
		const flagHealthcareWorker = healthcareWorker.value;
		console.log(flagHealthcareWorker);

		// 医療従事者確認フラグがある場合
		//　医療従事者確認はデフォルト非表示状態とする
		if(flagHealthcareWorker == 1){
			popupBtnYes.addEventListener('click', () => {
				console.log('Yes');
				// 値にYESをいれてcookieをセット
				setCookie('awi_user_popup','Yes',30);
				// そのままモーダルを閉じる
				popup.classList.add("-disabled");
			});

			popupBtnNo.addEventListener('click', () => {
				console.log('No');
				// トップページに飛ばす
				location.href = '/';
			});

			// cookieの確認
			const cookie = getCookie('awi_user_popup');

			if(!cookie || cookie !== 'Yes'){
				popup.classList.remove("-disabled");
			}
		}

	}

});
